module.exports = __webpack_public_path__ + "1fba971528300b8aa46da436f0c0ee28.pdf";